import React, { useEffect } from 'react';
import { Tooltip } from 'antd';
import IconContainer from 'assets/customSVG/sequence/actions/IconContainer';
import FullArrow from 'assets/customSVG/FullArrow';
import { cn } from 'helper/cn';

export default function TriggerListContainer({
  triggers,
  onTriggerClick,
  allow,
  isAfterApiTrigger
}) {
  // open tempalte message for api trigger
  const openTemplateMessageForApiTrigger = () => {
    const trigger = triggers?.find((trigger) => trigger?.key === 'TEMPLATE');
    if (trigger) {
      onTriggerClick(trigger);
    }
  } 

  useEffect(() => {
    if (isAfterApiTrigger) {
      openTemplateMessageForApiTrigger();
    }
  }, [isAfterApiTrigger])

  return (
    <div className='w-full h-auto flex flex-col items-center gap-2.5 px-4 py-2.5'>
      {triggers?.map((trigger) => {
        const Icon = trigger?.icon;
        return (
          <div
            key={trigger?.id}
            className={cn(
              'w-full h-12 flex items-center justify-between gap-2.5 border rounded-lg p-2.5',
              trigger?.disabled
                ? 'border-[var(--border-200)] bg-[var(--BG-100)] cursor-not-allowed opacity-50 hidden'
                : 'border-[var(--border-input)] cursor-pointer',
              !trigger?.canAdd ? 'bg-[var(--BG-100)] cursor-not-allowed opacity-50' : "hover:border-[var(--border-50)] hover:bg-[var(--BG-50)]"
            )}
            onClick={(event) => {
              event.stopPropagation();
              if (allow && onTriggerClick && !trigger?.disabled && trigger?.canAdd) {
                onTriggerClick(trigger);
              }
            }}
            title={trigger?.disabled && trigger.key !== 'TEMPLATE' && 'Only template messages are allowed after an API trigger'}
          >
            <div className='w-full flex items-center gap-2.5'>
              {Icon && (
                <IconContainer color={trigger?.bg}>
                  <Icon color={trigger?.color} />
                </IconContainer>
              )}
              <p className={cn(
                'text-sm weight-medium',
                trigger?.disabled ? 'text-[var(--contentText-300)]' : 'text-[var(--contentText)]'
              )}>
                {trigger?.label}
                {trigger?.disabled && trigger.key !== 'TEMPLATE' && (
                  <span className='ml-2 text-xs text-amber-500'>
                    (Not allowed after API Trigger)
                  </span>
                )}
              </p>
            </div>
            <div className='size-6 flex items-center justify-center'>
              <FullArrow
                width={16}
                height={16}
                color={'#898E99'}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}
